import { render, staticRenderFns } from "./step_4.vue?vue&type=template&id=647a58e2&scoped=true&"
import script from "./step_4.vue?vue&type=script&lang=js&"
export * from "./step_4.vue?vue&type=script&lang=js&"
import style0 from "./step_4.vue?vue&type=style&index=0&id=647a58e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647a58e2",
  null
  
)

export default component.exports